import { FilterQuery, SortOrder } from "mongoose";
import { Device } from "./Device";

export enum ConnectivityReportStatus {
	ERROR = "ERROR",
	TIMEOUT = "TIMEOUT",
	SUCCESS = "SUCCESS",
}

export interface ConnectivityReport {
	_id: string;
	deviceId: string;
	permissionaryId: string;
	ipAddress: string;
	port: number;
	status: ConnectivityReportStatus;
	timestamp: number; //timestamp which the report was generated

	device?: Device;
}

export interface ConnectivityReportSearchDto {
	query: FilterQuery<ConnectivityReport>;
	sort: Record<string, SortOrder>;
	offset: number;
	limit: number;
	timestampRange: { from: number; end: number };
}
